import objectHash from 'object-hash';

const Profile = {
  subscriptionsHash: (profile) => {
    const subscriptions = profile?.subscriptions?.length
      ? profile?.subscriptions
      : profile?.currentSubscriptions?.length || profile?.pastSubscriptions?.length
      ? [...(profile?.pastSubscriptions ?? []), ...(profile?.currentSubscriptions ?? [])]
      : [];

    if (subscriptions?.length) {
      return objectHash(subscriptions);
    }

    return null;
  }
};

export default Profile;
